import React from 'react';
import LoadingSpinner from './loadingSpinner'
// import C18Button00 from './C18Button00'
// import C18Anchor00 from './C18Anchor00'
// import config from '../../components/utils/config'
// import {wsTrans} from '../utils/utils'
import {cl,ocf} from '../../components/utils/utils';
// import {toggleAClass,hasAClass,removeAClass} from '../utils/utils';
// import {gitCommitHash,gitBranch} from '../../generatedGitInfo.json'
// import {loadUser,loadAlarmsInfo,loadPrivsInfo,getAlarmInfo,alLevel,privs,loadSubscriptionInfo,
//   getRecurlyAccount,acctFeature,loadAddedSensorsInfo,loadMBInfo,loadUsersInfo,
//   getSuperUserFlags,
// } from './C18utils'
// var version="a.b.c"
// cl(version)
var co={
  lineHgt:64,
  pctWid:6.4,
}

class C18MenuSim extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.state={
      loaded:true,
    }
  }

  screens={
    status:`\
labL	0	0	COOL6
labL	0	30	SetPt
labL	0	53	70.0
labL	1	5	InT
labL	1	22	--- \u00B0F
labL	1	56	Rel Hum
labL	2	5	OutT
labL	2	22	--- \u00B0F
labL	2	56	--- %
labL	2	82	DH2
labL	3	2	10
labL	3	9	:
labL	3	11	50
labL	3	22	AM
labL	3	36	Thu
labL	3	56	10
labL	3	65	/
labL	3	69	16
labL	3	78	/
labL	3	81	2025
labL	4	4	Hydro3
`
  }

  but=(e,val)=>{
    cl(val)
  }

  showMenu=(scrId)=>{
    cl(co.lineHgt)
    cl(co)
    let els=this.screens[scrId].split("\n").map((l,i)=>{
      let [type,r,c,k1,k2,k3,mn,mx]=l.split("\t")
      if(type){
//         cl(type,r,c,k1)
        switch(type){
          case "labL":
//             cl(co.lineHgt,r,co.lineHgt*r)
//             let top=co.lineHgt*+r-50
//             let left=co.pctWid*+c
//             cl(top,left)
            return(
              <div key={i} style={{position:"absolute",
                top:co.lineHgt*r-14,
                left:co.pctWid*c,
                width:640,
                fontSize:66,
                transform:"scaleX(0.65)",
                transformOrigin:"left",
                color:"#CCEEFF"}}>
              {k1}
              </div>
            )

            break
          default:
            break
        }
      }
    })
    let tdStyle={cursor:"pointer"}
    return(
      <div style={{width:640}}>
        <div style={{position:"relative",width:640,height:320,backgroundColor:"black"}}>
        {els}
        </div>
        <div style={{textAlign:"center"}}>
          <table style={{width:"initial",display:"inline-block"}}><tbody>
          <tr>
          <td style={tdStyle} onClick={ocf(this.but,"pEx")}>
            <img src="/images/nav/pEx.png" width="64"/></td>
          <td style={tdStyle} onClick={ocf(this.but,"pUp")}>
            <img src="/images/nav/pUp.png" width="64"/></td>
          <td style={tdStyle} onClick={ocf(this.but,"pEn")}>
            <img src="/images/nav/pEn.png" width="64"/></td>
          </tr>
          <tr>
          <td style={tdStyle} onClick={ocf(this.but,"pLf")}>
            <img src="/images/nav/pLf.png" width="64"/></td>
          <td style={tdStyle} onClick={ocf(this.but,"pDn")}>
            <img src="/images/nav/pDn.png" width="64"/></td>
          <td style={tdStyle} onClick={ocf(this.but,"pRt")}>
            <img src="/images/nav/pRt.png" width="64"/></td>
          </tr>
          </tbody></table>
        </div>
      </div>
    )
  }

  render(){
//     cl(this.state)
    if(this.state.loaded){
      return this.showMenu("status")
    }else{
      return <LoadingSpinner message="loading menu simulator..." />
    }
  }
}

export default C18MenuSim;
